
import { IAppConfigState, ISystemConfigInfo } from './app-config-types.store';

export class AppConfigState implements IAppConfigState {
	formDataConfigs: Object;
	systemAppConfigs: Object;
	userAppConfigs: Object;
	systemConfigInfo: ISystemConfigInfo;
    constructor() {
		this.formDataConfigs = {};
		this.systemAppConfigs = {};
		this.userAppConfigs = {};
		this.systemConfigInfo = null;
    }
}

